import hasWhitespacesOnly from './common/hasWhitespacesOnly';
import incorrectDataType from './common/incorrectDataType';
import isEmpty from './common/isEmpty';
import isNull from './common/isNull';
import isUndefined from './common/isUndefined';

export const isValidIfsc = (ifsc) => {
  if (
    isNull(ifsc) ||
    isUndefined(ifsc) ||
    incorrectDataType(ifsc, 'string') ||
    hasWhitespacesOnly(ifsc) ||
    isEmpty(ifsc)
  ) {
    return false;
  } else {
    const regex_ifsc = new RegExp(/^[A-Z]{4}0[A-Z0-9]{6}$/);
    return (
      ifsc.length <= 11 &&
      regex_ifsc.test(ifsc)
    );
  }
};
